module.exports = __webpack_public_path__ + "static/banner_2-25e0b0039e64f35bdbcf1b390813071f.png";